import { styled } from 'styled-components';

export const SliderWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.sizing.small}
    ${({ theme }) => theme.sizing.medium};

  h3 {
    padding-left: ${({ theme }) => theme.sizing.tiny};
  }
`;
SliderWrapper.displayName = 'SliderWrapper';

export const slideAnimationStyle = 'cubic-bezier(0.465, 0.183, 0.153, 0.946)';

export const FormField = styled.div`
  position: relative;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '1rem'};

  // temp fix for slider button groups
  div[role='group'] {
    margin-top: ${({ theme }) => theme.sizing.regular};
  }
`;
FormField.displayName = 'FormField';

export const FormGroupEqual = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${({ $margin }) => $margin || '0 0 0.5rem'};

  > div {
    width: 100%;
    flex: 1 1 auto;
  }
`;
